module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iRUlt"))).then(() => parcelRequire('iDabs'));